// src/components/dashboard/employee/UpcomingTrainingsWidget.js
import React from 'react';
import { Table } from 'react-bootstrap';
import DashboardCard from '../DashboardCard';
import StatusBadge from '../StatusBadge';

function UpcomingTrainingsWidget({ trainings, loading }) {
  return (
    <DashboardCard
      title="Upcoming Trainings"
      icon="bi-calendar-event"
      loading={loading}
      isEmpty={!loading && trainings.length === 0}
      emptyMessage="No upcoming trainings assigned yet."
    >
      <Table borderless size="sm" className="mb-0 align-middle">
        <tbody>
          {trainings.map(t => (
            <tr key={t.id}>
              <td>
                <div className="fw-semibold">{t.title}</div>
                <div className="text-muted small">{t.code} &middot; {t.start_date} &middot; {t.location}</div>
              </td>
              <td className="text-end"><StatusBadge status={t.status} /></td>
            </tr>
          ))}
        </tbody>
      </Table>
    </DashboardCard>
  );
}

export default UpcomingTrainingsWidget;
